<template>
  <div class="record_wrap" @scroll="handleScroll" >
    <div class="record_item" v-for="(item, index) in luckDrawGoodsOrderVoList" >
      <div>
        <img :src="item.luckDrawGoodsPicUrl" class="winner_img" />
        <div class="winner_content" >
          <div>
            <div class="winner_title" >{{ item.luckDrawGoodsName }}</div>
<!--            <div class="winner_value" >价值<span>1999</span></div>-->
          </div>

          <div class="winner_date" >中奖日期：{{ item.createTime }}</div>
        </div>
      </div>
      <div class="opt_btn" v-if="item.storeCouponId ==='' && item.status === '1' && item.address === ''" @click="receiveAward(item)" >马上领取</div>
      <div class="logistics_btn" v-if="item.storeCouponId ==='' && item.address !== ''" @click="logistics(item.luckDrawGoodsOrderId)"  >查看物流</div>
      <div class="already_btn" v-if="item.storeCouponId" >已领取</div>
    </div>

    <van-empty description="暂无中奖记录" v-if="!loading && luckDrawGoodsOrderVoList.length <= 0" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getMyLuckDrawGoodsOrderVoList } from '@/api/luckdraw'
import moment from 'moment'
export default {
  name: 'winningRecord',
  data() {
    return {
      page: 1,
      pageSize: 15,
      luckDrawGoodsOrderVoList: [],
      moment,
      loading: false
    }
  },
  methods: {
    logistics(luckDrawGoodsOrderId) {
      this.$router.push({ name: 'logistics', params: { orderId: luckDrawGoodsOrderId, type: '2' } })
    },
    receiveAward(item) {
      localStorage.setItem('awardVo', JSON.stringify({...item}))
      this.$router.push({ name: 'receiveAward' })
    },
    handleScroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollTop + clientHeight >= scrollHeight - 50){
        this.page++
        this.getMyLuckDrawGoodsOrderVoList()
      }
    },
    getMyLuckDrawGoodsOrderVoList() {
      const { page, pageSize } = this
      this.loading = true
      getMyLuckDrawGoodsOrderVoList({ page, pageSize }).then(res => {
        this.loading = false
        if(res.success) {
          this.luckDrawGoodsOrderVoList = this.luckDrawGoodsOrderVoList.concat(res.data)
        }
      })
    },
  },
  mounted() {
    this.getMyLuckDrawGoodsOrderVoList()
  }
}
</script>
